import { objectDestructuringEmpty as _objectDestructuringEmpty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logNavigation } from '../../cinnamon-core/es/modules/logging/tracking.js';

/**
 * Automatically triggers navigation log events on route changes
 */
var NavigationLogger = function NavigationLogger(_ref) {
  _objectDestructuringEmpty(_ref);

  var location = useLocation();
  var prevLocation = useRef(location);
  useEffect(function () {
    if (location !== prevLocation.current) {
      logNavigation(location.pathname, {
        previous: prevLocation.current.pathname,
        state: location.state
      });
    }

    prevLocation.current = location;
  }, [location]);
  return null;
};

var NavigationLogger$1 = NavigationLogger;

export { NavigationLogger$1 as default };
